import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedDate } from 'react-intl';

import { H3, RadioList } from '../components/';
import Calendar from '~COMPONENTS/formInputs/selectComponents/Calendar';
import Filter from '~COMPONENTS/filters/Filter';

import { TranslatedCopy } from '../intl/TranslatedCopy';

import { dateWithoutTimezone, dateIsToday, todaysDate } from '../util/dateWithoutTimezone';
import { TWO_YEARS_AGO } from '../util/constants';
import { CUSTOM_DATE_RANGE, DEFAULT_DATE_RANGE } from '../shop/constants';

class DateRangeSelector extends Component {
  constructor(props) {
    super(props);
    const {
      dateRange,
      dateRange: { period }
    } = this.props;
    this.state = {
      showCalendar: dateRange && period === CUSTOM_DATE_RANGE
    };
  }

  componentDidUpdate(prevProps) {
    const {
      dateRange,
      dateRange: { period }
    } = this.props;
    if (dateRange && prevProps.dateRange.period !== DEFAULT_DATE_RANGE && period === DEFAULT_DATE_RANGE) {
      this.setShowCalendar(false);
    }
  }

  setShowCalendar = bool => this.setState({ showCalendar: bool });

  getDate = dateString => {
    const date = dateString ? new Date(dateString) : new Date(Date.now());
    const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
    const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
    return `${date.getFullYear()}-${month}-${day}`;
  };

  dateToString = date => new Date(date).toISOString();

  handleDateRange = async ({ value }) => {
    const { filterList, resetPage, updateDateRange } = this.props;
    await updateDateRange({ period: value });
    await resetPage();
    if (value === 'custom') {
      await this.handleDateSelection();
      this.setShowCalendar(true);
    } else {
      this.setShowCalendar(false);
    }

    filterList();
  };

  handleDateSelection = async (val, isStart) => {
    const { filterList, resetPage, updateDateRange, dateRange } = this.props;
    const date = this.getDate(new Date());
    dateRange.period = 'custom';

    if (isStart) {
      dateRange.startDate = val;
      dateRange.endDate = dateRange.endDate || date;
    } else {
      dateRange.startDate = dateRange.startDate || date;
      dateRange.endDate = val || date;
    }

    await updateDateRange(dateRange);
    await resetPage();
    filterList();
  };

  render() {
    const { dateRange, dateRangeOptions } = this.props;
    const { showCalendar } = this.state;

    const startDate = dateWithoutTimezone(dateRange.startDate);
    const endDate = dateWithoutTimezone(dateRange.endDate);
    const twoYearsAgo = new Date(Date.now() - TWO_YEARS_AGO);
    const today = todaysDate();
    return (
      <div className='filters dateRange'>
        <div className='dateRange__title d-sm-h d-lg-b prl6-sm'>
          <H3>
            <TranslatedCopy id='global.date' />
          </H3>
        </div>
        <Filter
          id='date'
          trigger={
            <>
              <div className='d-sm-b d-lg-h'>
                <TranslatedCopy id='global.date' />
              </div>
              <div className='d-sm-h d-lg-b mr2-lg'>
                <TranslatedCopy id={`orderstatus.date.select.${dateRange.period.split(' ')[0]}`} noWrap />
              </div>
            </>
          }
          closeOnOutsideClick
        >
          <RadioList
            options={dateRangeOptions}
            value={dateRange.period}
            onChange={this.handleDateRange}
            name='returnStatus__date'
          />
        </Filter>

        {showCalendar && (
          <>
            <Calendar
              startDate={twoYearsAgo}
              endDate={endDate < today ? endDate : today}
              onChange={this.handleDateSelection}
              value={
                // eslint-disable-next-line
                dateRange.startDate ? dateRange.startDate : null
              }
              buttonLabel={
                dateIsToday(startDate, today) ? (
                  <TranslatedCopy id='orderstatus.date.today' />
                ) : (
                  <FormattedDate value={startDate} year='2-digit' month='numeric' day='numeric' />
                )
              }
              isStart
            />
            <Calendar
              startDate={startDate}
              endDate={today}
              onChange={this.handleDateSelection}
              value={
                // eslint-disable-next-line
                dateRange.endDate ? dateRange.endDate : null
              }
              buttonLabel={
                dateIsToday(endDate, today) ? (
                  <TranslatedCopy id='orderstatus.date.today' />
                ) : (
                  <FormattedDate value={endDate} year='2-digit' month='numeric' day='numeric' />
                )
              }
            />
          </>
        )}
      </div>
    );
  }
}

DateRangeSelector.propTypes = {
  dateRange: PropTypes.shape({
    period: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string
  }).isRequired,
  dateRangeOptions: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })).isRequired,
  filterList: PropTypes.func.isRequired,
  resetPage: PropTypes.func.isRequired,
  updateDateRange: PropTypes.func.isRequired
};

export default DateRangeSelector;
